// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hwVN6mkQnHQNyY6bo3k5{cursor:pointer;display:inline-grid}.hwVN6mkQnHQNyY6bo3k5.Zzgr0tkIlfwFywAOOiNa{cursor:default;pointer-events:none}.AMoBruoc6I4TeOf9ay1u{grid-area:1/1}.GeQQsmgkXjMZXnNzHXKE{visibility:visible}.EJ5aylAePUkgulClQcT_{visibility:hidden;pointer-events:none}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `hwVN6mkQnHQNyY6bo3k5`,
	"copied": `Zzgr0tkIlfwFywAOOiNa`,
	"layer": `AMoBruoc6I4TeOf9ay1u`,
	"visible": `GeQQsmgkXjMZXnNzHXKE`,
	"hidden": `EJ5aylAePUkgulClQcT_`
};
export default ___CSS_LOADER_EXPORT___;
